import * as auth from '../../services/auth.service';

const state = {
    isLoggrdIn:null,
    profile:{},
};

const getters = {
    getUserProfile:state => (state.profile),
};

const actions = {
    fetchAuthanticate({commit}){
        let userInfo='';
        const isLogged = auth.isLoggedIn();
        if(isLogged){
             userInfo = auth.getUserFromToken();
        }else{
            userInfo = {};
        }
        commit('authanticate', userInfo);
    },
};

const mutations = {
    authanticate:(state, res) => (
        state.profile =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}